
import './style.scss'

interface LabeledTextAreaProps {
	label?: string
	onChange: (newValue: string) => void
	value?: string
	disabled?: boolean
}

function LabeledTextArea({label, onChange, value, disabled}: LabeledTextAreaProps) {
	
	const valueChangeHandler = (newValue: string) => {
		onChange(newValue)
	}

	return (
		<div className='labeled-input-wrap'>
			{label && 
				<span className='labeled-input-label'>{label}</span>
			}
			<textarea
				className='labeled-input-input labeled-input-text-area'
				value={value}
				onChange={(event) => {
					valueChangeHandler(event.target.value)
				}}
				disabled={disabled}
			/>
		</div>
	)
}

export default LabeledTextArea